@for (config of list; track config) {
<div #notif [ngClass]="config.type" [id]="'notification-' + config.id" class="notification">
  <span class="icon-wrapper">
    <svg class="notify-icon" width="16" height="16">
      <use spriteVersion [iconName]="config.type + '-icon-notify'"></use>
    </svg>
  </span>
  <p class="text">{{config.msg}}</p>
  <button type="button" class="close-icon-btn" (click)="closeNotification(config)">
    <svg class="close-icon" width="20" height="20">
      <use spriteVersion iconName="close-icon"></use>
    </svg>
  </button>
</div>
}
